module.exports = __webpack_public_path__ + "who-dropped-the-price-first.svg?526d779ca8979941760929cbcc30a739";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/who-dropped-the-price-first.svg
// module id = 332
// module chunks = 2